import { paths } from "../../common-fetch/generated/orders-model-api";
import { definitions } from "../../common-fetch/generated/partners-model-api";
import { fetchItJson } from "../../common-fetch/miscellaneous/fetchItJson";
import { FetchOutput } from "../../common-fetch/miscellaneous/fetchResult";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";
import { OverrideOrder } from "./orderAtom";

type Path = paths["/orders"];
export type Responses = Path["get"]["responses"];

export type Order200Schema = OverrideOrder<Responses["200"]["schema"]>;

export type FetchOrdersOutput = FetchOutput<
  Order200Schema,
  definitions["ProblemDetails"]
>;

export async function fetchGetOrders(): Promise<FetchOrdersOutput> {
  const path: keyof paths = "/orders";

  return fetchItJson<Order200Schema, definitions["ProblemDetails"]>(
    "authorization",
    `${getPartnerPathnameClient(true)}/Market/HostedCart/Orders/v1${path}`
  ).catch(() => {
    return { tag: "client-error", parsed: { status: 418 } };
  });
}
